/* SwissTopo WMTS layer definitions. Free public endpoints, no API key required. */
/* Docs: https://www.geo.admin.ch/en/geo-services/geo-services/portrayal-services-web-mapping/wmts.html */

const TPL = (layer, format = "jpeg", time = "current") =>
  `https://wmts.geo.admin.ch/1.0.0/${layer}/default/${time}/3857/{z}/{x}/{y}.${format}`;

export const SWISSTOPO_BASE_LAYERS = [
  {
    id: "swissimage",
    label: "Foto satellitari (SwissImage)",
    url: TPL("ch.swisstopo.swissimage", "jpeg"),
    attribution: "© swisstopo",
    group: "Sfondo",
    default: true,
  },
  {
    id: "swisstlm3d",
    label: "Mappa topografica a colori",
    url: TPL("ch.swisstopo.pixelkarte-farbe", "jpeg"),
    attribution: "© swisstopo",
    group: "Sfondo",
  },
  {
    id: "pixelkarte-grau",
    label: "Mappa topografica (b/n)",
    url: TPL("ch.swisstopo.pixelkarte-grau", "jpeg"),
    attribution: "© swisstopo",
    group: "Sfondo",
  },
];

export const SWISSTOPO_OVERLAYS = [
  {
    id: "relief",
    label: "Rilievo ombreggiato (SwissALTI3D)",
    url: TPL("ch.swisstopo.swissalti3d-reliefschattierung", "png"),
    attribution: "© swisstopo SwissALTI3D",
    opacity: 0.55,
    group: "Rilievo e geologia",
  },
  {
    id: "geologia",
    label: "Geologia (GeoCover)",
    url: TPL("ch.swisstopo.geologie-geocover", "png"),
    attribution: "© swisstopo geologie",
    opacity: 0.7,
    group: "Rilievo e geologia",
    featureInfo: true,
    bodLayerId: "ch.swisstopo.geologie-geocover",
  },
  {
    id: "swissimage1946",
    label: "Foto storiche 1946",
    url: TPL("ch.swisstopo.swissimage-product_1946", "jpeg", "1946"),
    attribution: "© swisstopo SwissImage 1946",
    opacity: 1,
    group: "Storico",
  },
  {
    id: "siegfried",
    label: "Carta Siegfried (1949)",
    url: TPL("ch.swisstopo.hiks-siegfried", "png", "1949"),
    attribution: "© swisstopo Carta Siegfried",
    opacity: 0.9,
    group: "Storico",
  },
  {
    id: "dufour",
    label: "Carta Dufour (1864)",
    url: TPL("ch.swisstopo.hiks-dufour", "png", "current"),
    attribution: "© swisstopo Carta Dufour",
    opacity: 0.9,
    group: "Storico",
  },
  {
    id: "vec200-names",
    label: "Toponimi (VEC200)",
    url: TPL("ch.swisstopo.vec200-names-namedlocation", "png"),
    attribution: "© swisstopo VEC200",
    opacity: 1,
    group: "Annotazioni",
  },
];

export const SWISSTOPO_ATTRIBUTION = '<a href="https://www.geo.admin.ch" target="_blank">© swisstopo</a>';

// SwissTopo REST API for feature info (identify)
export async function identifyFeatures({ layerBodIds, lat, lng, mapBounds, mapSize }) {
  if (!layerBodIds || layerBodIds.length === 0) return [];
  const layersParam = `all:${layerBodIds.join(",")}`;
  const params = new URLSearchParams({
    geometry: `${lng},${lat}`,
    geometryType: "esriGeometryPoint",
    geometryFormat: "geojson",
    layers: layersParam,
    tolerance: "10",
    returnGeometry: "false",
    mapExtent: `${mapBounds.west},${mapBounds.south},${mapBounds.east},${mapBounds.north}`,
    imageDisplay: `${mapSize.x},${mapSize.y},96`,
    sr: "4326",
    lang: "it",
  });
  const r = await fetch(`https://api3.geo.admin.ch/rest/services/api/MapServer/identify?${params}`);
  if (!r.ok) return [];
  const data = await r.json();
  return data.results || [];
}

export async function fetchHtmlPopup(layerBodId, featureId) {
  const r = await fetch(
    `https://api3.geo.admin.ch/rest/services/api/MapServer/${layerBodId}/${featureId}/htmlPopup?lang=it`,
  );
  if (!r.ok) return null;
  return await r.text();
}

// Default Swiss view center (approximate centre of Switzerland) + zoom
export const SWISS_CENTER = [46.8, 8.3];
export const SWISS_DEFAULT_ZOOM = 8;
